<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title" i18n>Sign Document</h6>
          <div class="required-fields-label">
            <ng-container *ngIf="editor?.getUnfilledRequiredFieldsCount() as count">
              <ng-container i18n>Required fields:</ng-container>
              <span class="bg-primary rounded-circle required-field-count">{{ count }}</span>
            </ng-container>
          </div>
        </div>
        <div class="flex-fill"></div>
        <button
          type="button"
          class="btn btn-secondary-light"
          [disabled]="isProcessing || editor?.isLoading"
          (click)="editor?.nextField()"
        >
          <ng-container i18n>Next</ng-container> <i class="far fa-chevron-double-right"></i>
        </button>
        <button
          type="button"
          class="btn btn-secondary-danger"
          [disabled]="isProcessing || editor?.isLoading"
          (click)="editor?.declineContract()"
        >
          <i class="far fa-minus-circle"></i> <ng-container i18n>Decline</ng-container>
        </button>
        <button
          type="button"
          class="btn btn-secondary-info"
          [disabled]="isProcessing || editor?.isLoading || !editor?.isFullFilled()"
          (click)="editor?.signContract()"
        >
          <i class="far fa-pen-alt"></i> <ng-container i18n>Sign It</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <!-- /.modal-header -->
    <div class="modal-body">
      <app-sign-editor
        #editor
        [contract]="contract"
        [isProcessing]="isProcessing"
        (sign)="onSignContract($event)"
        (decline)="onDeclineContract()"
      ></app-sign-editor>
    </div>
  </div>
</div>
